import { Params, Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { getActiveItemsIds } from '../../service/DeclarationHelper';
import { normalizeIds } from '../../service/GridHelpers/GridHelpers';
import { GridSourceHelper } from '../../service/GridSourceHelper';
import { Session } from '../../service/Session/Session';
import { campaigns, ClientInfo } from '../../typings/common';
import { CampaignsCalcTypeFilter } from '../../typings/domain';
import {
    GridScreenUrlSearchQueryParams,
    GridScreenUrlSearchRouteParams,
    GridSourceParams
} from '../../typings/grid';
import { State } from '../../typings/state';

export const selectGridSourceParams = createSelector(
    (state: State) => state.commonData.login,
    (state: State) => state.router.pathname,
    (state: State) => state.router.query,
    (state: State) => state.router.params,
    (state: State) => state.commonData.features.isBidCorrectionSearchEnabled,
    (state: State) => state.grid.clientInfo,
    (
        login: string,
        pathname: string,
        routerQuery: Query,
        routerParams: Params,
        isBidCorrectionSearchEnabled: boolean,
        clientInfo: ClientInfo
    ): GridSourceParams => {
        const query = routerQuery || {};
        const params = routerParams || {};

        // TODO DIRECT-95861 унести от сюда обращение в localStorage. Учесть то, что ls возвращает каждый раз новые данные
        const {
            campaignsIds,
            groupsIds,
            goalsSettings,
            alertMessageFilter = {},
            campaignsCalcTypeFilter
        } = Session.getValueFromCurrentSession(login);

        const goalIds = getActiveItemsIds(goalsSettings);
        const view = params[GridScreenUrlSearchRouteParams.view] || campaigns;
        const filter = query[GridScreenUrlSearchQueryParams.filter];

        return GridSourceHelper.normalizeSourceParams(
            {
                viewString: view,
                campaignsIds:
                    normalizeIds(
                        query[GridScreenUrlSearchQueryParams.campaignsIds]
                    ) ||
                    campaignsIds ||
                    [],
                groupsIds:
                    normalizeIds(
                        query[GridScreenUrlSearchQueryParams.groupsIds]
                    ) ||
                    groupsIds ||
                    [],
                goalIds: goalIds || [],
                sortKey: query[GridScreenUrlSearchQueryParams.sortKey] || '',
                sortDirection:
                    query[GridScreenUrlSearchQueryParams.sortDirection] || '',
                sortGoalId:
                    query[GridScreenUrlSearchQueryParams.sortGoalId] || '',
                statPreset:
                    query[GridScreenUrlSearchQueryParams.statPreset] || '',
                statFrom: query[GridScreenUrlSearchQueryParams.statFrom] || '',
                statTo: query[GridScreenUrlSearchQueryParams.statTo] || '',
                filter: filter || '',
                login: login || query[GridScreenUrlSearchQueryParams.ulogin],
                messageType: query[GridScreenUrlSearchQueryParams.messageType],
                alertMessageFilter: alertMessageFilter[view],
                campaignsCalcTypeFilter:
                    CampaignsCalcTypeFilter[
                        query[GridScreenUrlSearchQueryParams.calcType]
                    ] ||
                    campaignsCalcTypeFilter ||
                    CampaignsCalcTypeFilter.CPC,
                clientInfo
            },
            pathname,
            isBidCorrectionSearchEnabled
        );
    }
);
